import StyleSheet from 'react-native-media-query';
import {
  BASESTYLE,
  COLORS,
  FONT_NAMES,
  FixedValue,
  Percentage,
} from '../../constants';
import {IColorTheme} from '../../types/contextTypes/themeContext';
import {normalizeFont, scaleHeight, scaleWidth} from '../../utils/responsive';

export const deleteCollectionModalStyle = (theme: IColorTheme) =>
  StyleSheet.create({
    subContainer: {
      width: Percentage.PRECENTAGE_100,
      backgroundColor: theme.backgroundColor,
      paddingHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_20),
      paddingTop: scaleHeight(FixedValue.CONSTANT_VALUE_15),
      paddingBottom: scaleHeight(FixedValue.CONSTANT_VALUE_18),
      borderTopLeftRadius: FixedValue.CONSTANT_VALUE_18,
      borderTopRightRadius: FixedValue.CONSTANT_VALUE_18,
      shadowColor: COLORS._333333,
      shadowOffset: {
        width: FixedValue.CONSTANT_VALUE_0,
        height: -FixedValue.CONSTANT_VALUE_3,
      },
      shadowOpacity: FixedValue.CONSTANT_VALUE_03,
      elevation: FixedValue.CONSTANT_VALUE_3,
    },
    container: {
      width: Percentage.PRECENTAGE_100,
      paddingBottom: scaleHeight(FixedValue.CONSTANT_VALUE_18),
    },
    activeTabButton: {
      ...BASESTYLE.inCenter,
      ...BASESTYLE.row,
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_25),
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      paddingHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_20),
      width: Percentage.PRECENTAGE_100,
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_10),
    },
    crossImage: {
      alignItems: 'flex-end',
    },
    iWant: {
      ...BASESTYLE.textAlignCenter,
      fontFamily: FONT_NAMES.SF_REGULAR,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      color: theme.color,
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_20),
    },
    moveOrDelete: {
      ...BASESTYLE.textAlignCenter,
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_10),
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_30),
      color: COLORS.PRIMARY_BLUE,
      fontFamily: FONT_NAMES.SF_MEDIUM,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
    },
    sure: {
      fontFamily: FONT_NAMES.SF_MEDIUM,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      color: theme.color,
    },
    wantDelete: {
      ...BASESTYLE.textAlignCenter,
      color: theme.color,
      fontFamily: FONT_NAMES.SF_MEDIUM,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_10),
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_15),
    },
    wantDelete2: {
      ...BASESTYLE.textAlignCenter,
      color: theme.color,
      fontFamily: FONT_NAMES.SF_REGULAR,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_16),
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_10),
    },
    deleteWarning: {
      ...BASESTYLE.textAlignCenter,
      fontFamily: FONT_NAMES.SF_MEDIUM,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_10),
      color: COLORS.F54336,
      paddingHorizontal: scaleWidth(FixedValue.CONSTANT_VALUE_12),
    },
    deleteBinView: {
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_59),
      width: scaleWidth(FixedValue.CONSTANT_VALUE_59),
      borderRadius: scaleWidth(FixedValue.CONSTANT_VALUE_59),
      marginBottom: scaleHeight(FixedValue.CONSTANT_VALUE_19),
      backgroundColor: COLORS._FFEBEB,
    },
    textColorWhite: {
      color: COLORS.WHITE,
    },
    textColorPrimaryBlue: {
      color: COLORS.PRIMARY_BLUE,
    },
    backgroundColorLighBlue: {
      backgroundColor: COLORS.E9EEFB,
    },
    backgroundColorPrimaryBlue: {
      backgroundColor: COLORS.PRIMARY_BLUE,
    },
    marginRight10: {
      marginRight: scaleWidth(FixedValue.CONSTANT_VALUE_10),
    },
    marginTop20: {
      marginTop: scaleHeight(FixedValue.CONSTANT_VALUE_20),
    },
    deleteTextStyle: {
      ...BASESTYLE.textAlignCenter,
      fontFamily: FONT_NAMES.SF_MEDIUM,
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
    },
    warningView: {
      ...BASESTYLE.inCenter,
      backgroundColor: COLORS.FDE4E1,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_46),
      width: scaleWidth(FixedValue.CONSTANT_VALUE_309),
      borderRadius: FixedValue.CONSTANT_VALUE_26,
    },
    countinueButtonView: {
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      width: scaleHeight(FixedValue.CONSTANT_VALUE_335),
      borderRadius: FixedValue.CONSTANT_VALUE_100,
    },
    continueButtonLabelstyle: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_22),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: COLORS.WHITE,
    },
    yesOrNoButtonView: {
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      width: scaleHeight(FixedValue.CONSTANT_VALUE_105),
      borderRadius: FixedValue.CONSTANT_VALUE_100,
    },
    yesButtonLabelstyle: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_17),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: COLORS.WHITE,
    },
    primaryButtonStyle: {
      ...BASESTYLE.inCenter,
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      borderRadius: FixedValue.CONSTANT_VALUE_100,
      width: scaleHeight(FixedValue.CONSTANT_VALUE_159_5),
    },
    primaryButtonStyle2: {
      height: scaleHeight(FixedValue.CONSTANT_VALUE_48),
      ...BASESTYLE.inCenter,
      borderRadius: FixedValue.CONSTANT_VALUE_100,
      marginRight: scaleWidth(FixedValue.CONSTANT_VALUE_8),
      width: scaleHeight(FixedValue.CONSTANT_VALUE_159_5),
    },
    marginLeft16: {
      marginLeft: scaleWidth(FixedValue.CONSTANT_VALUE_16),
    },
    noButtonBackGroundColor: {
      backgroundColor: COLORS.E9EEFB,
    },
    noButtonLabelstyle: {
      fontSize: normalizeFont(FixedValue.CONSTANT_VALUE_14),
      lineHeight: normalizeFont(FixedValue.CONSTANT_VALUE_17),
      fontFamily: FONT_NAMES.SF_MEDIUM,
      color: COLORS.PRIMARY_BLUE,
    },
  });
